import React from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import cardCover from '../../assets/cover/card_cover.webp'

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    padding: theme.spacing(4),
    boxShadow: 'none'
  },
  media: {
    backgroundImage: `url(${cardCover})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '2rem',
  }
}));

const GuardiansCard = ({guardian}) => {
  const classes = useStyles();

  return (
    <>
      <Card className={classes.card}>
        <CardMedia
          alt={guardian.alt}
          className={classes.media}
          component="img"
          image={guardian.img}
          object-fit
          title={guardian.title}
        />
        <CardContent>
          <Typography
            align="center"
            component="h3"
            gutterBottom
            style={{margin: '2rem 0'}}
            variant="h3"
          >
            {guardian.name}
          </Typography>
          <Typography
            align="center"
            component="p"
            variant="body2"
          >
            {guardian.desc}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}

GuardiansCard.propTypes = {
  guardian: PropTypes.object,
};

export default GuardiansCard;
